/**
 * @generated SignedSource<<87b4bdbae2c550f597002c6ee9fb47f6>>
 * @relayHash b8b88d147c7eb62f67c19879e2cfd483
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 25c6ac3bae0cee1b3b729753b9fb852cd76633c1d0e754b76d4ef819490bd827

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type uiHorizontalSoftwareProjectNavQuery$variables = {
  boardId?: string | null | undefined;
  cloudId: string;
  projectKey: string;
};
export type uiHorizontalSoftwareProjectNavQuery$data = {
  readonly jira: {
    readonly jiraProjectByKey: {
      readonly action: {
        readonly canPerform: boolean;
      } | null | undefined;
    } | null | undefined;
    readonly jiraSoftwareNavigationItems: {
      readonly " $fragmentSpreads": FragmentRefs<"ui_navigationKitTabList_TabList">;
    };
  };
};
export type uiHorizontalSoftwareProjectNavQuery = {
  response: uiHorizontalSoftwareProjectNavQuery$data;
  variables: uiHorizontalSoftwareProjectNavQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "boardId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v3 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v4 = [
  (v3/*: any*/),
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "projectKey"
  }
],
v5 = {
  "args": [
    {
      "kind": "Literal",
      "name": "type",
      "value": "EDIT_PROJECT_CONFIG"
    }
  ],
  "concreteType": "JiraProjectAction",
  "kind": "LinkedField",
  "name": "action",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "canPerform"
    }
  ],
  "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
},
v6 = [
  {
    "kind": "Variable",
    "name": "boardId",
    "variableName": "boardId"
  },
  (v3/*: any*/),
  {
    "kind": "Variable",
    "name": "projectIdOrKey",
    "variableName": "projectKey"
  }
],
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = {
  "kind": "ScalarField",
  "name": "label"
},
v9 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v10 = {
  "kind": "ScalarField",
  "name": "iconUrl"
},
v11 = {
  "kind": "ScalarField",
  "name": "url"
},
v12 = {
  "kind": "ScalarField",
  "name": "styleClass"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "uiHorizontalSoftwareProjectNavQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "args": (v4/*: any*/),
              "concreteType": "JiraProject",
              "kind": "LinkedField",
              "name": "jiraProjectByKey",
              "plural": false,
              "selections": [
                (v5/*: any*/)
              ]
            },
            {
              "kind": "RequiredField",
              "field": {
                "args": (v6/*: any*/),
                "concreteType": "JiraNavigationItemConnection",
                "kind": "LinkedField",
                "name": "jiraSoftwareNavigationItems",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "ui_navigationKitTabList_TabList"
                  }
                ]
              },
              "action": "THROW",
              "path": "jira.jiraSoftwareNavigationItems"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "uiHorizontalSoftwareProjectNavQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v7/*: any*/)
            ]
          },
          {
            "args": (v6/*: any*/),
            "concreteType": "JiraNavigationItemConnection",
            "kind": "LinkedField",
            "name": "jiraSoftwareNavigationItems",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraNavigationItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v7/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "isDefault"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "typeKey"
                      },
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isJiraNavigationItem"
                      },
                      (v8/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "canRemove"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "canSetAsDefault"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v9/*: any*/)
                            ],
                            "type": "JiraNavigationItem",
                            "abstractKey": "__isJiraNavigationItem"
                          }
                        ],
                        "type": "JiraWorkManagementSavedView"
                      },
                      (v9/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "JiraAppSection",
                            "kind": "LinkedField",
                            "name": "sections",
                            "plural": true,
                            "selections": [
                              (v8/*: any*/),
                              {
                                "concreteType": "JiraAppNavigationItemNestedLink",
                                "kind": "LinkedField",
                                "name": "links",
                                "plural": true,
                                "selections": [
                                  (v8/*: any*/),
                                  (v10/*: any*/),
                                  (v11/*: any*/),
                                  (v12/*: any*/)
                                ]
                              }
                            ]
                          },
                          (v11/*: any*/),
                          (v10/*: any*/),
                          (v12/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "appType"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "envLabel"
                          }
                        ],
                        "type": "JiraAppNavigationItem"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "25c6ac3bae0cee1b3b729753b9fb852cd76633c1d0e754b76d4ef819490bd827",
    "metadata": {},
    "name": "uiHorizontalSoftwareProjectNavQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "cc12d798a25264ec9d04143058744a65";

export default node;
